<template>
  <div>
    <h1>OS1</h1>
    <v-select
      v-model="teamid"
      :items="teams"
      item-value="id"
      label="Team"
      @change="navigate"
      outline
    >
      <template slot="selection" slot-scope="data"
        >{{ data.item.code }} - {{ data.item.name }}</template
      >
      <template slot="item" slot-scope="data"
        >{{ data.item.code }} - {{ data.item.name }}</template
      >
      <template slot="append-outer" v-if="teamid">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <a
              @click="
                teamid = null;
                navigate();
              "
              v-on="on"
            >
              <v-icon>clear</v-icon>
            </a>
          </template>
          <span>Show all teams</span>
        </v-tooltip>
      </template>
    </v-select>
    <v-data-table
      :headers="headers"
      :items="modifiedFiles"
      hide-actions
      class="elevation-1"
      :pagination.sync="pagination"
      :loading="loading"
    >
      <template v-slot:items="props">
        <tr>
          <td>
            <FileZ :file="props.item" />
          </td>
          <td>{{ props.item.os1date | formatDate }}</td>
          <td>{{ props.item.age }}</td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import TEAMS from "@/graphql/directory/Teams";
import FileZ from "@/components/link/FileZ";
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "Os1",
  metaInfo() {
    return {
      title: "OS1",
      titleTemplate: "%s - File - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  components: { FileZ },
  apollo: {
    teams: {
      query: TEAMS,
      variables: { archived: false },
      fetchPolicy: "cache-and-network"
    }
  },
  computed: {
    modifiedFiles() {
      if (!this.files) {
        return undefined;
      }
      return this.files.map((f) => {
        const now = new Date();
        const os1date = new Date(f.os1date);
        const diff = now.getTime() - os1date.getTime();
        const age = Math.round(diff / (1000 * 3600 * 24));
        // let subject = "OS1 expires today";
        // let detail = "OS1 expires today";
        // if (age > 0) {
        //   subject = "OS1 expired";
        //   detail = "OS1 expired " + age + " days ago";
        // } else if (age < 0) {
        //   subject = "OS1 expiring soon";
        //   detail = "OS1 expires in " + -age + " days";
        // }
        return {
          ...f,
          age
        };
      });
    }
  },
  data() {
    return {
      teamid: null,
      files: [],
      headers: [
        {
          text: "Reference",
          value: "referencelong"
        },
        {
          text: "Due date",
          value: "os1date"
        },
        {
          text: "Remaining (days)",
          value: "age"
        }
      ],
      pagination: {
        sortBy: "timestamp",
        descending: false,
        page: 1,
        rowsPerPage: -1
      },
      loading: false
    };
  },
  methods: {
    fetchOs1() {
      this.files = [];
      if (this.teamid) {
        this.loading = true;
        nbmlaw
          .get(`/cors/admin/directory/teams/${this.teamid}/os1`)
          .then((response) => {
            // console.log(response.data);
            this.files = response.data;
            this.loading = false;
          })
          .catch(() => {});
      }
    },
    navigate() {
      this.$router.push({
        name: "os1",
        query: { teamid: this.teamid }
      });
    }
  },
  watch: {
    "$route.query.teamid": {
      immediate: true,
      handler() {
        this.teamid = this.$route.query.teamid;
        this.fetchOs1();
      }
    }
  }
};
</script>

<style>
</style>
